import { render, staticRenderFns } from "./SplitObject.vue?vue&type=template&id=d2b993d6&scoped=true"
import script from "./SplitObject.vue?vue&type=script&lang=js"
export * from "./SplitObject.vue?vue&type=script&lang=js"
import style0 from "./SplitObject.vue?vue&type=style&index=0&id=d2b993d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b993d6",
  null
  
)

export default component.exports